import React from "react";
// import { createColumnHelper, flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { useTable } from 'react-table';

import { Puff } from 'react-loading-icons';
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiOutlineChevronLeft, HiOutlineChevronRight } from "react-icons/hi";
import { AiFillInfoCircle, AiOutlineSelect } from "react-icons/ai";
import { BsArrowUpShort, BsArrowDownShort } from "react-icons/bs";

import DownloadTable from '../main/DownloadTable';

import axios from "axios";
import $ from 'jquery'; 





// to use ROWSPAN to display embedded rows
function useInstance(instance) {

    const { allColumns } = instance;

    let rowSpanHeaders = [];

    allColumns.forEach((column, i) => {

        const { id, enableRowSpan } = column;

        if (enableRowSpan !== undefined) {
            rowSpanHeaders = [
                ...rowSpanHeaders,
                { id, topCellValue: null, topCellIndex: 0 }
            ];
        }
    });

    Object.assign(instance, { rowSpanHeaders });
}
  


// TABLE
function SignaturesTable(props){

    // for download
    const column_headers = [
        {
            label: 'ID',
            key: 'signature_id',
        },
        {
            label: 'Response Components Type',
            key: 'response_components_type',
        },
        {
            label: 'Description',
            key: 'description',
        },
        {
            label: 'Comparison',
            key: 'comparison',
        },
        {
            label: 'Arm ID',
            key: 'arm_id',
        },
        {
            label: 'Planned Visit ID',
            key: 'planned_visit_id',
        },
        {
            label: 'Dataset Description',
            key: 'dataset_description',
        },
        {
            label: 'Target Entity Type',
            key: 'signature_target_entity_type',
        },
        {
            label: 'Target Entity Subtype',
            key: 'signature_target_entity_subtype',
        },
        {
            label: 'Assay Type',
            key: 'signature_assay_type',
        },
        {
            label: 'PMID',
            key: 'signature_pmid',
        },
        {
            label: 'Disease Name',
            key: 'signature_disease_name',
        },
        {
            label: 'Disease Stage',
            key: 'signature_disease_stage',
        },
        {
            label: 'Disease Severity',
            key: 'signature_disease_severity',
        }
    ]

    // here you set a state to tell the component it need to wait
    //  until the result is fetched from the api
    const [loadingData, setLoadingData] = React.useState(true);
  

    // define columns data, useMemo so the data isn't recreated on every render
    const columns = React.useMemo(
        () => [
            {
                Header: 'Signature ID',
                accessor: 'signature_id', // accessor is the "key" in the data
                enableRowSpan: true,
                enableClickOrder: true,
                minWidth: 150,
            },
            {
                Header: 'Response Components Type',
                accessor: 'response_components_type',
                enableRowSpan: true,
                enableClickOrder: true,
                minWidth: 260,
            },
            {
                Header: 'Description',
                accessor: 'description',
                enableRowSpan: true,
                minWidth: 400,
            },
            {
                Header: 'Comparison',
                accessor: 'comparison',
                enableRowSpan: true,
                minWidth: 400,
            },
            {
                Header: 'Arm ID',
                accessor: 'arm_id',
                enableRowSpan: true,
                minWidth: 130,
            },
            {
                Header: 'Planned Visit ID',
                accessor: 'planned_visit_id',
                minWidth: 130,
            },
            {
                Header: 'Dataset Description',
                accessor: 'dataset_description',
                minWidth: 400,
            },
            {
                Header: 'Target Entity Type',
                accessor: 'signature_target_entity_type',
                enableRowSpan: true,
                minWidth: 180,
            },
            {
                Header: 'Target Entity Subtype',
                accessor: 'signature_target_entity_subtype',
                enableRowSpan: true,
                minWidth: 210,
            },
            {
                Header: 'Assay Type',
                accessor: 'signature_assay_type',
                enableRowSpan: true,
                minWidth: 130,
            },
            {
                Header: 'PMID',
                accessor: 'signature_pmid',
                enableRowSpan: true,
                minWidth: 150,
            },
            {
                Header: 'Disease Name',
                accessor: 'signature_disease_name',
                enableRowSpan: true,
                minWidth: 160,
            },
            {
                Header: 'Disease Stage',
                accessor: 'signature_disease_stage',
                enableRowSpan: true,
                minWidth: 160,
            },
            {
                Header: 'Disease Severity',
                accessor: 'signature_disease_severity',
                enableRowSpan: true,
                minWidth: 170,
            },
        ],
    []
    )
  

    // use state to update data on load, currentpage, etc.
    const [data, setData] = React.useState([]);
    const [ordering, setOrdering] = React.useState();
    const [ordering_dir, setOrderingDir] = React.useState();
    const [pageNumber, setPageNumber] = React.useState();
    const [currentPage, setCurrentPage] = React.useState(1);
    const [inputPageValue, setInputPageValue] = React.useState('1');
    const [start, setStart] = React.useState(0);
    const [hasPrevious, setHasPrevious] = React.useState(false);
    const [hasNext, setHasNext] = React.useState(true);
    const offset = 50;

    const query = props.query;
    
    

    // full data url for download button
    const full_data_url = window.location.protocol + '//' + window.location.host + '/api_kb/get_full_signatures_data/' + query;



    // define URL to fetch rows (s=start, o=offset, q=query)
    const data_url = (s, o, q) => {
        return window.location.protocol + '//' + window.location.host + '/api_kb/get_slice_signatures/'+s+'/'+o+'/' + q;
    }


    // GET DATA
    React.useEffect(() => {
        async function get_signatures_data(url) {
            await axios
                .get(url)
                .then((response_signatures) => {
                    // check if the data is populated
                    // console.log(response_signatures.data);
                    setData(response_signatures.data.data);
                    setOrdering(response_signatures.data.ordering);
                    setOrderingDir(response_signatures.data.ordering_dir);
                    setPageNumber(response_signatures.data.number_page);
                    if (response_signatures.data.number_page == 1){
                        setHasNext(false);
                    }
                    props.length(response_signatures.data.length, 'signatures');
                    // you tell it that you had the result
                    setLoadingData(false);
                });
        }

        if (loadingData) {

            var query_onload = query;

            if (query != ''){
                query_onload += '&onload=True';
            }
            else {
                query_onload += '?onload=True';
            }

            const url = data_url(start, offset, query_onload);

            // if the result is not ready so you make the axios call
            get_signatures_data(url);
        }
    }, 
    []);




    // PAGINATION FUNCTIONNALITIES
    const nextPage = () => {

        async function get_signature_data(url) {
            await axios
                .get(url)
                .then((response_signature) => {
                    // check if the data is populated
                    // console.log(response_signature);
                    setData(response_signature.data.data);
                    setLoadingData(false);
                });
        }

        const next = start+offset;
        setStart(next);
        setCurrentPage(currentPage+1);
        setLoadingData(true);

        setHasPrevious(true);
        if (currentPage+1 === pageNumber){
            setHasNext(false);    
        }

        const url = data_url(next, offset, query);
        get_signature_data(url);

    }

    const previousPage = () => {

        async function get_signature_data(url) {
            await axios
                .get(url)
                .then((response_signature) => {
                    // check if the data is populated
                    // console.log(response_signature);
                    setData(response_signature.data.data);
                    setLoadingData(false);
                });
        }

        const previous = start-offset;
        setStart(previous);
        setCurrentPage(currentPage-1);
        setLoadingData(true);

        setHasNext(true);
        if (currentPage-1 === 1){
            setHasPrevious(false);    
        }

        const url = data_url(previous, offset, query);
        get_signature_data(url);

    }

    const firstPage = () => {

        async function get_signature_data(url) {
            await axios
                .get(url)
                .then((response_signature) => {
                    // check if the data is populated
                    // console.log(response_signature);
                    setData(response_signature.data.data);
                    setLoadingData(false);
                });
        }

        const start = 0;
        setStart(start);
        setCurrentPage(1);
        setHasPrevious(false);
        setHasNext(true);
        setLoadingData(true);

        const url = data_url(start, offset, query);
        get_signature_data(url);

    }

    const lastPage = () => {

        async function get_signature_data(url) {
            await axios
                .get(url)
                .then((response_signature) => {
                    // check if the data is populated
                    // console.log(response_signature);
                    setData(response_signature.data.data);
                    setLoadingData(false);
                });
        }

        const start = (pageNumber-1)*offset;
        setStart(start);
        setCurrentPage(pageNumber);
        setHasNext(false);
        setHasPrevious(true);
        setLoadingData(true);

        const url = data_url(start, offset, query);
        get_signature_data(url);

    }

    // checks on go to page
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            const page = Number(inputPageValue) - 1;
        
            if (page >= 1 && page <= pageNumber - 1) {
                gotoPage(page);

                if (page == 1) {
                    setHasNext(true);
                    setHasPrevious(false);    
                }

                else if (page == pageNumber){
                    setHasNext(false);
                    setHasPrevious(true);    
                }

                else {
                    setHasNext(true);
                    setHasPrevious(true);    
                }
            } 
            
            else if (page < 1) {
                gotoPage(0);
                setHasNext(true);
                setHasPrevious(false);
            } 
            
            else if (page > pageNumber - 1) {
                gotoPage(pageNumber - 1);
                setHasNext(false);
                setHasPrevious(true);
            }

        }, 1000); // Wait 1000ms after user stops typing
    
        return () => clearTimeout(timeout); // Clear if user types again
    
    }, [inputPageValue]); //execute when inputPageValue changes
    
    const gotoPage = (pageInt) => {

        async function get_signature_data(url) {
            await axios
                .get(url)
                .then((response_signature) => {
                    // check if the data is populated
                    // console.log(response_signature);
                    setData(response_signature.data.data);
                    setLoadingData(false);
                });
        }

        const start = (pageInt)*offset;
        setStart(start);
        setCurrentPage(pageInt+1);
        setLoadingData(true);

        if (pageInt+1 === pageNumber){
            setHasNext(false);
            setHasPrevious(true);    
        }
        else if (pageInt === 0){
            setHasNext(true);
            setHasPrevious(false);    
        }

        const url = data_url(start, offset, query);
        get_signature_data(url);

    }


      


    // DEFINE TABLE
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows,    
        rowSpanHeaders
    } = 
    useTable(
        { columns, data }, 
        (hooks) => { hooks.useInstance.push(useInstance); }
    )




    // RENDER
    return(

        <div className='SignaturesTable'>

            <div>

                <div className="results-table">

                <table {...getTableProps()}>
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th className={column.enableClickOrder ? "column-pointer" : ""} {...column.getHeaderProps({ style: { minWidth: column.minWidth } })} 
                                            onClick={ column.enableClickOrder ? () => {  
                                                if (ordering===column.id && ordering_dir==='asc'){
                                                    props.onColumnOrdering(column.id, 'desc');
                                                }
                                                else {
                                                    props.onColumnOrdering(column.id, 'asc');
                                                }

                                            } : null }
                                        > 
                                            {column.render('Header')}
                                            { column.enableClickOrder ? 
                                                (
                                                    <div className="column-order-icons">
                                                        <i className={( ordering===column.id && ordering_dir==='asc' ) ? "order-selected" : ""}><BsArrowUpShort/></i>
                                                        <i className={( ordering===column.id && ordering_dir==='desc' ) ? "order-selected" : ""}><BsArrowDownShort/></i>
                                                    </div>
                                                )
                                                : null 
                                            }
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        {loadingData ? (
                            <div className="loader-container">
                                <Puff stroke="#ccd8de" strokeWidth={5}/>
                                <p>Loading...</p>
                            </div>
                        ):(

                            <tbody {...getTableBodyProps()}>
                                {rows.map((row, i) => {
                                    prepareRow(row);

                                    for (let j = 0; j < row.allCells.length; j++) {
                                        let cell = row.allCells[j];
                                        
                                        // cell for response_components_type, description, comparison, arm_id
                                        let cell_component_type = row.allCells[1];
                                        let cell_description = row.allCells[2];
                                        let cell_comparison = row.allCells[3];
                                        let cell_arm = row.allCells[4];

                                        let rowSpanHeader = rowSpanHeaders.find(
                                            (x) => x.id === cell.column.id
                                        );


                                        // increase rowspan signature id
                                        if (rowSpanHeader !== undefined && rowSpanHeader.id === "signature_id") {

                                            if (rowSpanHeader.topCellValue === null || rowSpanHeader.topCellValue !== cell.value) {
                                                rowSpanHeader.topCellValue = cell.value;
                                                rowSpanHeader.topCellIndex = i;

                                                cell.isRowSpanned = false;
                                                cell_component_type.isRowSpanned = false;
                                                cell_description.isRowSpanned = false;
                                                cell_comparison.isRowSpanned = false;
                                                cell_arm.isRowSpanned = false;

                                                cell.rowSpan = 1;
                                                cell_component_type.rowSpan = 1;
                                                cell_description.rowSpan = 1;
                                                cell_comparison.rowSpan = 1;
                                                cell_arm.rowSpan = 1;

                                            } 
                                            
                                            else if (row.original.signature_id === rows[rowSpanHeader.topCellIndex].original.signature_id){
                                                rows[rowSpanHeader.topCellIndex].allCells[0].rowSpan++;
                                                cell.isRowSpanned = true;

                                                // give the same rowspan to response_components_type, description, comparison, arm_id
                                                rows[rowSpanHeader.topCellIndex].allCells[1].rowSpan++;
                                                rows[rowSpanHeader.topCellIndex].allCells[2].rowSpan++;
                                                rows[rowSpanHeader.topCellIndex].allCells[3].rowSpan++;
                                                rows[rowSpanHeader.topCellIndex].allCells[4].rowSpan++;
                                                cell_component_type.isRowSpanned = true;
                                                cell_description.isRowSpanned = true;
                                                cell_comparison.isRowSpanned = true;
                                                cell_arm.isRowSpanned = true;
                                                
                                            }
                                        }

                                    }

                                    return null;
                                })}

                                {rows.map((row) => {

                                    return (
                                        <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            if (cell.isRowSpanned) return null;
                                            else
                                            return (
                                                <td
                                                rowSpan={cell.rowSpan}
                                                {...cell.getCellProps()}
                                                >
                                                {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        
                        )}

                    </table>

                </div>

        
                <div className="pagination">
                    <button className="border-left" onClick={() => firstPage()} disabled={!hasPrevious}> <HiChevronDoubleLeft/> </button>
                    
                    <button onClick={() => previousPage()} disabled={!hasPrevious}> <HiOutlineChevronLeft/> </button>
                    
                    <div className="page-info">
                        <p><strong>{currentPage}</strong> of {pageNumber}</p>
                    </div>

                    <button onClick={() => nextPage() } disabled={!hasNext}> <HiOutlineChevronRight/> </button>
                    
                    <button className="border-right" onClick={() => lastPage()} disabled={!hasNext}> <HiChevronDoubleRight/> </button>
                    
                    <span className='current-page'> 
                        <span> Go to page:{' '}
                            <input type="number" min="1" max={pageNumber} defaultValue={1} onChange={(e) => setInputPageValue(e.target.value)}/>
                        </span> 
                    </span>  

                    <DownloadTable table_name={"Signatures Table"} url={full_data_url} columns_headers={column_headers} filename="signature-table"/>

                </div>

            </div>
            
        </div>
    ) 
}

export default SignaturesTable;